import { classNames } from "@/react/helpers/twMergeWithCN";
import type { PaymentMethodType } from "@/react/types/Paywalls/PaymentMethodTypes";
import { paymentMethodTypes } from "@/react/types/Paywalls/PaymentMethodTypes";
import type { IconProps } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";
import type { Variant, VariantProps } from "./types";

const iconTypeMap: Record<PaymentMethodType, IconProps["type"]> = {
  [paymentMethodTypes.affirm]: "paywalls-affirm",
  [paymentMethodTypes.afterpay_clearpay]: "paywalls-afterpay",
  [paymentMethodTypes.apple_pay]: "paywalls-apple-pay",
  [paymentMethodTypes.bancontact]: "paywalls-bancontact",
  [paymentMethodTypes.card]: "paywalls-card-generic",
  [paymentMethodTypes.google_pay]: "paywalls-google-pay",
  [paymentMethodTypes.ideal]: "paywalls-ideal",
  [paymentMethodTypes.klarna]: "paywalls-klarna",
  [paymentMethodTypes.link]: "paywalls-link",
  [paymentMethodTypes.pix]: "paywalls-pix",
  [paymentMethodTypes.sepa_debit]: "paywalls-sepa-debit",
  [paymentMethodTypes.revenue_cat_app_store]: "paywalls-apple-pay",
  [paymentMethodTypes.revenue_cat_play_store]: "paywalls-google-pay",
};
const variantPropsMap: Record<Variant, VariantProps> = {
  sm: {
    size: 16,
    className: "!w-4 !h-4",
  },
  md: {
    size: 24,
    className: "!w-6 !h-6",
  },
  lg: {
    size: 36,
    className: "!w-9 !h-9",
  },
  xl: {
    size: 48,
    className: "!w-12 !h-12",
  },
};

const usingStrokeColor: PaymentMethodType[] = [paymentMethodTypes.card];
const usingFillColor: PaymentMethodType[] = [
  paymentMethodTypes.affirm,
  paymentMethodTypes.apple_pay,
];

export interface TypeIconProps {
  className?: string;
  type: PaymentMethodType;
  variant: Variant;
}
export const TypeIcon = ({ className, variant, type }: TypeIconProps) => {
  const iconType = iconTypeMap[type];
  const { className: iconVariantClassName, ...iconVariantProps } =
    variantPropsMap[variant];

  const shouldUseStrokeCurrentColor = usingStrokeColor.includes(type);
  const shouldUseFillCurrentColor = usingFillColor.includes(type);

  return (
    <Icon
      {...iconVariantProps}
      className={classNames(className, iconVariantClassName)}
      useWithStrokeCurrentColor={shouldUseStrokeCurrentColor}
      useWithFillCurrentColor={shouldUseFillCurrentColor}
      type={iconType}
    />
  );
};
